<template>
  <!-- 问诊单通用样式 -->
  <div class="question-paper" v-if="formData">
    <!-- 中医问诊单内容 -->
    <template>
      <div class="card">
        <div class="card-header">
          <h3>转诊单</h3>
          <!--
          <span class="date">复诊时间：{{formData.start_time | dateFilter}}-{{formData.end_time | timeFilter}}</span>
          -->
        </div>
        <div class="card-content">
          <div class="baseinfo-item">
            <div class="type">就诊人信息</div>
            <div class="content">
              <div class="patient-info">{{formData.pat.pat_username}}<span>|</span>{{formData.pat.gender | genderFilter}}<span>|</span>{{formData.pat.birthday | ageFilter}}</div>
            </div>
          </div>
          <!--
          <div class="baseinfo-item">
            <div class="type">最近一次就诊医院</div>
            <div class="content">{{formData.hospital|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">最近一次就诊科室</div>
            <div class="content">{{formData.last_depname|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">疾病名称</div>
            <div class="content">{{formData.disease|| '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">症状变化</div>
            <div class="content">{{formData.sym_change}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.is_anesis != 3">
            <div class="type">是否得到缓解</div>
            <div class="content">{{formData.is_anesis == 1 ? '是' : '否'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">本次就诊急需改善的症状</div>
            <div class="content">{{formData.improve || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">其他不舒服或希望治疗的症状</div>
            <div class="content">{{formData.symptom || '无'}}</div>
          </div>
-->
          <div class="baseinfo-item">
            <div class="type">转诊原因</div>
            <div class="content">{{formData.referral_reason || '无'}}</div>
          </div>
          <div class="baseinfo-item">
            <div class="type">病史</div>
            <div class="content">{{formData.record_txt || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.record_img && formData.record_img.length > 0">

            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.record_img, index)" v-for="(item, index) in formData.record_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
          <div class="baseinfo-item">
            <div class="type">诊断</div>
            <div class="content">{{formData.report_txt || '无'}}</div>
          </div>
          <div class="baseinfo-item" v-if="formData.report_img && formData.report_img.length > 0">

            <div class="content">
              <div class="question-image-wrapper">
                <div class="question-image" @click="previewImage(formData.report_img, index)" v-for="(item, index) in formData.report_img"><img
                    :src="item"></div>
              </div>
            </div>
          </div>
          <div class="baseinfo-item">
            <div class="type">转诊医生</div>
            <div class="doc-box">
              <div class="doc-info" @click="changeDoc()" v-if="formData.refer_docid==0">
                <div class="info">
                  <div class="avatar"><img :src="formData.recomdoc.avatar" alt=""></div>
                  <div class="info-text">
                    <div class="name">{{formData.recomdoc.username}}<span>{{formData.recomdoc.title | jobTitleFilter}}</span></div>
                    <div class="title">{{formData.recomdoc.work_unit}}</div>
                    <div class="department"><span>{{formData.recomdoc.p_dep_title}}</span>|<span>{{formData.recomdoc.dep_title}}</span></div>
                  </div>
                </div>
              </div>
              <div class="doc-info" @click="changeDoc()" v-else>
                <div class="info">
                  <div class="avatar"><img :src="docEntry.avatar" alt=""></div>
                  <div class="info-text">
                    <div class="name">{{docEntry.username}}<span>{{docEntry.title | jobTitleFilter}}</span></div>
                    <div class="title">{{docEntry.work_unit}}</div>
                    <div class="department"><span>{{docEntry.p_dep_title}}</span>|<span>{{docEntry.dep_title}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
    <!-- 选择开方剂型弹窗 -->
    <van-popup v-model="chooseDoctor" position="bottom">
      <div class="popup-wrapper">
        <div class="popup-header">
          选择转诊医生
          <span class="close-popup" @click="chooseDoctor = false">取消</span>
        </div>
        <div class="formulation-wrapper">
          <div class="doc-list" v-if="referDocList.length > 0">
            <div class="doc-item" :key="index" v-for="(item, index) in referDocList">
              <div class="doc-box" @click="selectDoc(item)">
                <div class="doc-info">
                  <div class="info">
                    <div class="avatar"><img :src="item.avatar" alt=""></div>
                    <div class="info-text">
                      <div class="name">{{item.username}}<span>{{item.title | jobTitleFilter}}</span></div>
                      <div class="title">{{item.work_unit}}</div>
                      <div class="department"><span>{{item.p_dep_title}}</span>|<span>{{item.dep_title}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 图片预览 -->
    <van-image-preview v-model="previewShow" :images="previewList" :start-position="imageIndex"></van-image-preview>
  </div>
</template>

<style lang="less" scoped>
  .question-paper{
    padding-top: 12px;
    .formulation-wrapper{
      padding: 5px 5px 0;

      min-height:500px;
      max-height:90%;;
      .doc-list{
        padding-top: 47px;
        width: 100%;
        .doc-item{
          width: 100%;
          transition: all .1s;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          &:active{
            background: #F9F9F9;
          }

        }
      }
    }
    .doc-box{
      margin-left: 0px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      border-bottom: 1px solid #EEE;
      padding: 14px 16px 14px 0;
      width: 100%;
      .avatar{
        width: 44px;
        height: 44px;
        overflow: hidden;
        border-radius: 50%;
        background: #F9F9F9;
        flex-shrink: 0;
        img{
          width: 100%;
        }
      }
      .doc-info{
        flex: 1;
        padding: 4px 0 0 12px;
      .info{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
      .avatar{
        width: 56px;
        height: 56px;
        overflow: hidden;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 100%;
        }
      }
      .info-text{
        width: 96%;
        margin-left: 8px;
        margin-top: 2px;
        .name{
          font-size: 15px;
          line-height: 18px;
          color: @black;
          padding-left: 8px;
          max-width: 90%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          span{
            padding-left: 10px;
            color: #999;
            font-size: 14px;
          }
        }
        .title{
          margin-top: 6px;
          color: #999;
          font-size: 14px;
          font-weight: normal;
          padding-left: 8px;
        }
        .department{
          margin-top: 8px;
          height: 24px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(0, 132, 138, 0.2);
          display: inline-flex;
          align-items: center;
          .xile-alpha(0.06);
          span{
            color: @xile;
            margin: 0 8px;
          }
        }
      }
    }
        .info-province{
          margin-top: 6px;
          font-size: 12px;
          line-height: 14px;
          color: #666666;
        }

      }
    }
    .card{
      border-radius: 6px;
      background: #FFF;
      overflow: hidden;
      &:not(:first-child){
        margin-top: 12px;
      }
      &.question-card{
        padding: 0 20px;
        .card-content{
          padding: 20px 0 0;
          border-bottom: 1px solid #EEE;
          .baseinfo-item:last-child{
            margin-bottom: 20px;
          }
        }
      }
      .card-header{
        padding: 20px 12px 16px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #FAFAFA;
        border-bottom: 1px solid #F3F3F3;
        h3{
          font-size: 20px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
        }
        .date{
          font-size: 14px;
          line-height: 14px;
          color: #666;
        }
      }
      .card-content{
        padding: 20px 16px 0;
        .baseinfo-item{
          margin-bottom: 32px;
          .type{
            font-size: 15px;
            line-height: 15px;
            color: #505050;
            font-weight: bold;
          }
          .content{
            margin-top: 8px;
            font-size: 15px;
            line-height: 20px;
            color: @black;

            .patient-info{
              vertical-align: middle;
              span{
                font-size: 12px;
                color: #CCC;
                margin: 0 12px;
                font-weight: normal;
              }
            }
          }
        }
        .question-image-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          .question-image{
            width: 96px;
            height: 96px;
            overflow: hidden;
            border-radius: 4px;
            margin-top:6px;
            margin-right: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            img{
              width: 100%;
            }
          }
        }
      }
      .question-header{
        height: 48px;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @wenzhen;
        border-bottom: 1px solid #EEE;
      }
      .question-list{
        margin-top: 16px;
        padding-bottom: 10px;
        &.west{
          margin-top: 20px;
        }
        .qa-item{
          color: @black;
          margin-bottom: 30px;
          .question{
            font-size: 16px;
            line-height: 16px;
          }
          .answer{
            margin-top: 20px;
            font-size: 15px;
            line-height: 15px;
            font-weight: bold;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      formData: {

      }
    },
    data() {
      return {
        previewShow: false,
        previewList: [],
        imageIndex: 0,
        chooseDoctor: false,
        referDocList: [],
        docEntry: {},
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      let _this = this;
      if (this.formData.refer_docid > 0) {
        this.docEntry = this.formData.referdoc;
      }
      this.getReferDocList();
    },
    methods: {
      changeDoc() {
        if(this.userInfo.user_id==this.formData.pat_id){
            this.chooseDoctor = true;
        }
      },
      getReferDocList() {
        // 获取患者基本信息以及处方基本信息
        this.$root.post('/getReferDocList', {
          doc_id: this.formData.ori_docid
        }).then(data => {
          console.log(data)
          this.referDocList = data || {};

        })
      },
      selectDoc(item) {

        this.docEntry = item;
        this.formData.refer_docid = item.user_id;;
        this.chooseDoctor = false;
        console.log("修改转诊医生")
        console.log(this.formData)
      },
      previewImage(image, index) {
        this.previewList = image;
        this.imageIndex = index;
        this.previewShow = true;
      }
    },
    filters: {
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD HH:mm');
      },
      timeFilter(stamp) {
        return moment.unix(stamp).format('HH:mm');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/referral.vue